import * as marietta from '../..';
import { ALMOST_ZERO } from '../Constants';
import { MonicaObject } from '../item';
import WebCADUtil, { RC_CLSTAT } from './WebCADUtil';

/**
 * guide Util クラス
 */
export default class ItemGuideUtil {
    static target: MonicaObject;

    /**
     * 一番近いの壁やアイテムを探す
     * @param p1 //開始点
     * @param p2 //終点
     * @param direction アイテムのどちら側から計算するか
     */
    static getClosestWallOrItem(target: MonicaObject, p1: marietta.core.Point, p2: marietta.core.Point, direction: string) {
      this.target = target;

      const newPoint: marietta.core.Point = marietta.core.Point.interpolate(p1, p2, 0.5); // 中心点

      // 近い壁を探す
      const closestWalls = []; // 最も近い壁のリスト
      const closestPointsS = []; // 開始点に最も近いクロスポイントのリスト
      const closestPointsE = []; // 終点に最も近いクロスポイントのリスト
      let crossPoint: marietta.core.Point;
      let crossPointS: marietta.core.Point; // 開始点に最も近いクロスポイント
      let crossPointE: marietta.core.Point; // 終点に最も近いクロスポイント
      const wallList: marietta.webcad.collection.RoomWallCollection[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList; // APIから処理された壁リスト

      // 斜めの壁の交差点を計算するための点
      const newPointE: marietta.core.Point = newPoint.clone();
      const p1End: marietta.core.Point = p1.clone();
      const p2End: marietta.core.Point = p2.clone();

      let showDiffLine: boolean = true;
      let wallCrossPoint: marietta.core.Point;
      for (let i: number = 0; i < wallList.length; i += 1) {
        showDiffLine = true;
        crossPoint = WebCADUtil.calculateCrossPoint(wallList[i].startPoint, wallList[i].endPoint, newPoint);
        crossPointS = WebCADUtil.calculateCrossPoint(wallList[i].startPoint, wallList[i].endPoint, p1);
        crossPointE = WebCADUtil.calculateCrossPoint(wallList[i].startPoint, wallList[i].endPoint, p2);
        switch (direction) {
          case 'top':
            if (WebCADUtil.CheckLineStatus(p1, p2, wallList[i].startPoint, wallList[i].endPoint) !== RC_CLSTAT.PARALLEL && (wallList[i].startPoint.y !== wallList[i].endPoint.y && wallList[i].startPoint.x !== wallList[i].endPoint.x)) {
              p1End.y = wallList[i].startPoint.y < wallList[i].endPoint.y ? wallList[i].startPoint.y - 20 : wallList[i].endPoint.y - 20;
              p2End.y = p1End.y;
              newPointE.y = p1End.y;
              crossPoint = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, newPoint, newPointE);
              crossPointS = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p1, p1End);
              crossPointE = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p2, p2End);
            }
            if (crossPoint != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPoint, direction);
              if (wallCrossPoint.y <= newPoint.y && ((wallCrossPoint.x - newPoint.x) < ALMOST_ZERO)) {
                closestWalls.push({
                  diffLine: { showDiffLine: false }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, newPoint), crossPoint: wallCrossPoint, startPoint: newPoint,
                });
              }
            }
            if (crossPointS != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointS, direction);
              if (wallCrossPoint.y <= p1.y && ((wallCrossPoint.x - p1.x) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.y === crossPointS.y) {
                  showDiffLine = false;
                }
                closestPointsS.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p1), crossPoint: wallCrossPoint, startPoint: p1,
                });
              }
            }
            if (crossPointE != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointE, direction);
              if (wallCrossPoint.y <= p2.y && ((wallCrossPoint.x - p2.x) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.y === crossPointE.y) {
                  showDiffLine = false;
                }
                closestPointsE.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p2), crossPoint: wallCrossPoint, startPoint: p2,
                });
              }
            }
            break;
          case 'right':
            if (WebCADUtil.CheckLineStatus(p1, p2, wallList[i].startPoint, wallList[i].endPoint) !== RC_CLSTAT.PARALLEL && (wallList[i].startPoint.y !== wallList[i].endPoint.y && wallList[i].startPoint.x !== wallList[i].endPoint.x)) {
              p1End.x = wallList[i].startPoint.x > wallList[i].endPoint.x ? wallList[i].startPoint.x + 20 : wallList[i].endPoint.x + 20;
              p2End.x = p1End.x;
              newPointE.x = p1End.x;
              crossPoint = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, newPoint, newPointE);
              crossPointS = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p1, p1End);
              crossPointE = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p2, p2End);
            }
            if (crossPoint != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPoint, direction);
              if (wallCrossPoint.x >= newPoint.x && ((wallCrossPoint.y - newPoint.y) < ALMOST_ZERO)) {
                closestWalls.push({
                  diffLine: { showDiffLine: false }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, newPoint), crossPoint: wallCrossPoint, startPoint: newPoint,
                });
              }
            }
            if (crossPointS != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointS, direction);
              if (wallCrossPoint.x >= p1.x && ((wallCrossPoint.y - p1.y) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.x === crossPointS.x) {
                  showDiffLine = false;
                }

                closestPointsS.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p1), crossPoint: wallCrossPoint, startPoint: p1,
                });
              }
            }
            if (crossPointE != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointE, direction);
              if (wallCrossPoint.x >= p2.x && ((wallCrossPoint.y - p2.y) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.x === crossPointE.x) {
                  showDiffLine = false;
                }
                closestPointsE.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p2), crossPoint: wallCrossPoint, startPoint: p2,
                });
              }
            }
            break;
          case 'bottom':
            if (WebCADUtil.CheckLineStatus(p1, p2, wallList[i].startPoint, wallList[i].endPoint) !== RC_CLSTAT.PARALLEL && (wallList[i].startPoint.y !== wallList[i].endPoint.y && wallList[i].startPoint.x !== wallList[i].endPoint.x)) {
              p1End.y = wallList[i].startPoint.y > wallList[i].endPoint.y ? wallList[i].startPoint.y + 20 : wallList[i].endPoint.y + 20;
              p2End.y = p1End.y;
              newPointE.y = p1End.y;
              crossPoint = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, newPoint, newPointE);
              crossPointS = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p1, p1End);
              crossPointE = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p2, p2End);
            }
            if (crossPoint != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPoint, direction);
              if (wallCrossPoint.y >= newPoint.y && ((wallCrossPoint.x - newPoint.x) < ALMOST_ZERO)) {
                closestWalls.push({
                  diffLine: { showDiffLine: false }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, newPoint), crossPoint: wallCrossPoint, startPoint: newPoint,
                });
              }
            }
            if (crossPointS != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointS, direction);
              if (wallCrossPoint.y >= p1.y && ((wallCrossPoint.x - p1.x) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.y === crossPointS.y) {
                  showDiffLine = false;
                }
                closestPointsS.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p1), crossPoint: wallCrossPoint, startPoint: p1,
                });
              }
            }
            if (crossPointE != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointE, direction);
              if (wallCrossPoint.y >= p2.y && ((wallCrossPoint.x - p2.x) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.y === crossPointE.y) {
                  showDiffLine = false;
                }
                closestPointsE.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p2), crossPoint: wallCrossPoint, startPoint: p2,
                });
              }
            }
            break;
          case 'left':
            if (WebCADUtil.CheckLineStatus(p1, p2, wallList[i].startPoint, wallList[i].endPoint) !== RC_CLSTAT.PARALLEL && (wallList[i].startPoint.y !== wallList[i].endPoint.y && wallList[i].startPoint.x !== wallList[i].endPoint.x)) {
              p1End.x = wallList[i].startPoint.x < wallList[i].endPoint.x ? wallList[i].startPoint.x - 20 : wallList[i].endPoint.x - 20;
              p2End.x = p1End.x;
              newPointE.x = p1End.x;
              crossPoint = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, newPoint, newPointE);
              crossPointS = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p1, p1End);
              crossPointE = WebCADUtil.IntersectionEdge(wallList[i].startPoint, wallList[i].endPoint, p2, p2End);
            }
            if (crossPoint != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPoint, direction);
              if (wallCrossPoint.x <= newPoint.x && ((wallCrossPoint.y - newPoint.y) < ALMOST_ZERO)) {
                closestWalls.push({
                  diffLine: { showDiffLine: false }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, newPoint), crossPoint: wallCrossPoint, startPoint: newPoint,
                });
              }
            }
            if (crossPointS != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointS, direction);
              if (wallCrossPoint.x <= p1.x && ((wallCrossPoint.y - p1.y) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.x === crossPointS.x) {
                  showDiffLine = false;
                }
                closestPointsS.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p1), crossPoint: wallCrossPoint, startPoint: p1,
                });
              }
            }
            if (crossPointE != null) {
              wallCrossPoint = this.getCorrectedWallPoint(crossPointE, direction);
              if (wallCrossPoint.x <= p2.x && ((wallCrossPoint.y - p2.y) < ALMOST_ZERO)) {
                if (crossPoint != null && crossPoint.x === crossPointE.x) {
                  showDiffLine = false;
                }

                closestPointsE.push({
                  diffLine: { showDiffLine }, line: { start: wallList[i].startPoint, end: wallList[i].endPoint }, distance: marietta.core.Point.distance(wallCrossPoint, p2), crossPoint: wallCrossPoint, startPoint: p2,
                });
              }
            }
            break;
          default: break;
        }
      }

      // アイテムと計算されたクロスポイントの間に他の壁ポイントがあるかどうかを確認
      if (closestPointsS.length > 0 && closestPointsE.length > 0) {
        const minStartPoint = closestPointsS.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));
        const minEndPoint = closestPointsE.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));

        const pointInside = this.getShortestPointsInside(p1, p2, minStartPoint, minEndPoint, direction);
        if (pointInside != null) {
          closestWalls.push(pointInside);
        } else {
          closestWalls.push(minStartPoint);
          closestWalls.push(minEndPoint);
        }
      }

      if (closestWalls.length < 1) return null;

      let minDistance = NaN;
      let start = null;
      let line: { start: marietta.webcad.view.dialog.core.Point; end: marietta.webcad.view.dialog.core.Point; };
      let diffLine: { showDiffLine: any; diffLinePoint: marietta.webcad.view.dialog.core.Point; };
      for (let i = 0; i < closestWalls.length; i += 1) {
        if (Number.isNaN(minDistance) || closestWalls[i].distance < minDistance) {
          minDistance = closestWalls[i].distance;
          crossPoint = closestWalls[i].crossPoint.clone();
          start = closestWalls[i].startPoint.clone();
          line = closestWalls[i].line;
          diffLine = closestWalls[i].diffLine;
        }
      }
      line.start = this.getCorrectedWallPoint(line.start, direction);
      line.end = this.getCorrectedWallPoint(line.end, direction);
      if (diffLine.showDiffLine) {
        diffLine.diffLinePoint = this.getGuideLinePoints(line, p1, p2);
        if (WebCADUtil.CheckLineStatus(p1, p2, line.start, line.end) !== RC_CLSTAT.PARALLEL) { diffLine.diffLinePoint = crossPoint; }
      }

      // アイテムは壁を超えていますかどうか
      if (this.checkIsPlacedOverWall(p1, p2)) {
        return null;
      }

      // 選択したアイテムと最も近い壁の間の他のアイテムを見つける
      const intersectItem = this.isItemIntersect(p1, p2, direction, { point: crossPoint, distance: minDistance, startPoint: start });
      if (intersectItem != null) {
        return intersectItem;
      }
      return {
        diffLine, line, isItem: false, point: crossPoint, distance: minDistance, startPoint: start,
      };
    }

    /**
     * アイテムが壁を越えているかどうかを調べる機能
     * @param p1
     * @param p2
     */
    static checkIsPlacedOverWall(p1: marietta.webcad.view.dialog.core.Point, p2: marietta.webcad.view.dialog.core.Point): boolean {
      const wallList = marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList;
      let isOverWall = false;
      for (let i: number = 0; i < wallList.length; i += 1) {
        if (WebCADUtil.IntersectionEdge(new marietta.core.Point(p1.x + marietta.webcad.WebCADGlobal.WALL_WIDTH / 2, p1.y + marietta.webcad.WebCADGlobal.WALL_WIDTH / 2), new marietta.core.Point(p2.x - marietta.webcad.WebCADGlobal.WALL_WIDTH / 2, p2.y - marietta.webcad.WebCADGlobal.WALL_WIDTH / 2), wallList[i].startPoint, wallList[i].endPoint) != null) {
          isOverWall = true;
          break;
        }
      }
      return isOverWall;
    }

    /**
     * アイテムと計算されたクロスポイントの間のポイントを見つける機能
     * @param p1
     * @param p2
     * @param start
     * @param end
     * @param direction
     */
    static getShortestPointsInside(p1: marietta.core.Point, p2: marietta.core.Point, start: any, end: any, direction: string) {
      const wallList = marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList;
      const pointList = [];
      for (let i: number = 0; i < wallList.length; i += 1) {
        // 手動壁
        if (wallList[i].id === 'manual') {
          const manualWallPointStart = this.getWallPointInside(p1, p2, start, end, wallList[i].startPoint, wallList[i].endPoint, direction);
          const manualWallPointEnd = this.getWallPointInside(p1, p2, start, end, wallList[i].endPoint, wallList[i].startPoint, direction);
          if (manualWallPointStart != null && (manualWallPointEnd == null || (manualWallPointEnd != null && manualWallPointEnd.distance > manualWallPointStart.distance))) {
            pointList.push(manualWallPointStart);
          } else if (manualWallPointEnd != null && (manualWallPointStart == null || (manualWallPointStart != null && manualWallPointStart.distance > manualWallPointEnd.distance))) {
            pointList.push(manualWallPointEnd);
          }
        } else {
          let wallPoint = this.getWallPointInside(p1, p2, start, end, wallList[i].startPoint, wallList[i].endPoint, direction);
          if (wallPoint != null) {
            pointList.push(wallPoint);
          }
          // 壁が別の壁とつながっていないとき
          if (wallList[i].end.wall_type === 0) {
            wallPoint = this.getWallPointInside(p1, p2, start, end, wallList[i].endPoint, wallList[i].startPoint, direction);
            if (wallPoint != null) {
              pointList.push(wallPoint);
            }
          }
        }
      }
      if (pointList.length < 1) return null;
      let point: any;
      let minDistance = NaN;
      for (let i = 0; i < pointList.length; i += 1) {
        if (Number.isNaN(minDistance) || pointList[i].distance < minDistance) {
          minDistance = pointList[i].distance;
          point = pointList[i];
        }
      }
      return point;
    }

    /**
     * 壁が長方形内にあるかどうかを確認し、クロスポイントと距離を返す関数
     * @param p1 始点
     * @param p2 終点
     * @param start クロスポイントスタート
     * @param end クロスポイントエンド
     * @param wallStartPoint 壁始点
     * @param wallEndPoint 壁終点
     * @param direction
     */
    static getWallPointInside(p1: marietta.core.Point, p2: marietta.core.Point, start: { crossPoint: marietta.webcad.view.dialog.core.Point; distance: number; }, end: { crossPoint: marietta.webcad.view.dialog.core.Point; distance: number; }, wallStartPoint: marietta.core.Point, wallEndPoint: marietta.core.Point, direction: string) {
      const p3 = start.crossPoint as marietta.core.Point;
      const p4 = end.crossPoint as marietta.core.Point;
      const rect: marietta.core.Point[] = [p1, p2, p4, p3];
      const centerPoint: marietta.core.Point = marietta.core.Point.interpolate(p1, p2, 0.5);
      let crossPointWithCenter: marietta.webcad.view.dialog.core.Point;
      let wallCrossPoint: marietta.core.Point;
      const crossPoint = WebCADUtil.calculateCrossPoint(wallStartPoint, wallEndPoint, centerPoint);
      if (WebCADUtil.isPointInsidePolygon(rect, wallStartPoint)) {
        let showDiffLine = true;
        const itemintersectionPoint = WebCADUtil.calculateCrossPoint(p1, p2, wallStartPoint);
        if (itemintersectionPoint != null) {
          crossPointWithCenter = WebCADUtil.calculateCrossPoint(wallStartPoint, wallEndPoint, itemintersectionPoint);
        }
        switch (direction) {
          case 'top':
            if (wallStartPoint.y > p3.y || wallStartPoint.y > p4.y) {
              if (itemintersectionPoint != null) {
                if (crossPoint != null && crossPointWithCenter != null && crossPoint.y === crossPointWithCenter.y) {
                  showDiffLine = false;
                }
                wallCrossPoint = this.getCorrectedWallPoint(wallStartPoint, direction);
                const distance = marietta.core.Point.distance(itemintersectionPoint, wallCrossPoint);
                if (distance < start.distance && distance < end.distance) {
                  return {
                    diffLine: { showDiffLine }, line: { start: wallStartPoint, end: wallEndPoint }, distance, crossPoint: wallCrossPoint, startPoint: itemintersectionPoint,
                  };
                }
              }
            }
            break;
          case 'right':
            if (wallStartPoint.x < p3.x || wallStartPoint.x < p4.x) {
              if (itemintersectionPoint != null) {
                if (crossPoint != null && crossPointWithCenter != null && crossPoint.x === crossPointWithCenter.x) {
                  showDiffLine = false;
                }
                wallCrossPoint = this.getCorrectedWallPoint(wallStartPoint, direction);
                const distance = marietta.core.Point.distance(itemintersectionPoint, wallCrossPoint);
                if (distance < start.distance && distance < end.distance) {
                  return {
                    diffLine: { showDiffLine }, line: { start: wallStartPoint, end: wallEndPoint }, distance, crossPoint: wallCrossPoint, startPoint: itemintersectionPoint,
                  };
                }
              }
            }
            break;
          case 'bottom':
            if (wallStartPoint.y < p3.y || wallStartPoint.y < p4.y) {
              if (itemintersectionPoint != null) {
                if (crossPoint != null && crossPointWithCenter != null && crossPoint.y === crossPointWithCenter.y) {
                  showDiffLine = false;
                }
                wallCrossPoint = this.getCorrectedWallPoint(wallStartPoint, direction);
                const distance = marietta.core.Point.distance(itemintersectionPoint, wallCrossPoint);
                if (distance < start.distance && distance < end.distance) {
                  return {
                    diffLine: { showDiffLine }, line: { start: wallStartPoint, end: wallEndPoint }, distance, crossPoint: wallCrossPoint, startPoint: itemintersectionPoint,
                  };
                }
              }
            }
            break;
          case 'left':
            if (wallStartPoint.x > p3.x || wallStartPoint.x > p4.x) {
              if (itemintersectionPoint != null) {
                if (crossPoint != null && crossPointWithCenter != null && crossPoint.x === crossPointWithCenter.x) {
                  showDiffLine = false;
                }
                wallCrossPoint = this.getCorrectedWallPoint(wallStartPoint, direction);
                const distance = marietta.core.Point.distance(itemintersectionPoint, wallCrossPoint);
                if (distance < start.distance && distance < end.distance) {
                  return {
                    diffLine: { showDiffLine }, line: { start: wallStartPoint, end: wallEndPoint }, distance, crossPoint: wallCrossPoint, startPoint: itemintersectionPoint,
                  };
                }
              }
            }
            break;
          default: break;
        }
      }
      return null;
    }

    /**
     * 壁の境界で壁のポイントを計算し、壁の幅を減らした後にポイントを返します
     * @param wallPoint
     * @param direction
     */
    static getCorrectedWallPoint(wallPoint: marietta.core.Point, direction: string): marietta.core.Point {
      const newWallPoint: marietta.core.Point = wallPoint.clone();
      switch (direction) {
        case 'top':
          newWallPoint.y += marietta.webcad.WebCADGlobal.WALL_WIDTH / 2;
          break;
        case 'right':
          newWallPoint.x -= marietta.webcad.WebCADGlobal.WALL_WIDTH / 2;
          break;
        case 'bottom':
          newWallPoint.y -= marietta.webcad.WebCADGlobal.WALL_WIDTH / 2;
          break;
        case 'left':
          newWallPoint.x += marietta.webcad.WebCADGlobal.WALL_WIDTH / 2;
          break;
        default: break;
      }

      return newWallPoint;
    }

    /**
     * 選択したアイテムと最も近い壁の間の他のアイテムを検索し、アイテムの交差点とアイテムまでの距離を返します
     * @param p1
     * @param p2
     * @param direction
     * @param closestWall
     */
    static isItemIntersect(point1: marietta.core.Point, point2: marietta.core.Point, direction: string, closestWall: any) {
      const newPoint: marietta.core.Point = marietta.core.Point.interpolate(point1, point2, 0.5);
      const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.FloorLayer;
      const furLayer = floorLayer.layer_furniture as marietta.webcad.layer.ItemLayer;
      const furnitureItems: MonicaObject[] = furLayer.getAllChildren(); // 家具リスト
      const equipmentLayer = floorLayer.layer_equipment as marietta.webcad.layer.ItemLayer;
      const equipmentItems: MonicaObject[] = equipmentLayer.getAllChildren(); // 住設リスト
      let itemList = furnitureItems.concat(equipmentItems);

      const columnLayer = floorLayer.layer_column as marietta.webcad.layer.ItemLayer;
      const columnItems: MonicaObject[] = columnLayer.getAllChildren(); // 住設リスト
      if (columnItems.length > 0) itemList = itemList.concat(columnItems);

      let boundBox: marietta.core.Rectangle; let topL: marietta.webcad.view.dialog.core.Point; let topR: marietta.webcad.view.dialog.core.Point; let bottomL: marietta.webcad.view.dialog.core.Point; let bottomR: marietta.webcad.view.dialog.core.Point;
      const p1 = point1.clone();
      const p2 = point2.clone();
      let crossPoint: marietta.core.Point;
      let crossPointS: marietta.core.Point;// 開始点に最も近いクロスポイント
      let crossPointE: marietta.core.Point; // 終点に最も近いクロスポイント
      let closestItem: { distance: any; diffLine: any; line: any; isItem?: boolean; item?: any; point?: any; startPoint?: marietta.webcad.view.dialog.core.Point; };
      const showDiffLine = true;
      const closestItems = [];
      for (let i = 0; i < itemList.length; i += 1) {
        closestItem = null;
        if ((itemList[i].itemInfo.id.substring(0, 3) === 'fur' && this.target.itemInfo.id.substring(0, 3) === 'fur') && (itemList[i].itemInfo.index === this.target.itemInfo.index)) {
          // 何もしません
        } else if ((itemList[i].itemInfo.id.substring(0, 3) === 'equ' && this.target.itemInfo.id.substring(0, 3) === 'fur') && (itemList[i].itemInfo.index === this.target.itemInfo.index)) {
          // 何もしません
        } else if ((itemList[i].itemInfo.id.substring(0, 3) === 'col' && this.target.itemInfo.id.substring(0, 3) === 'col') && (itemList[i].itemInfo.index === this.target.itemInfo.index)) {
          // 何もしません
        } else {
          boundBox = itemList[i].getBoundRect();
          if (itemList[i] instanceof marietta.webcad.item.Column) {
            topL = new marietta.core.Point(boundBox.x, boundBox.y);
            topR = new marietta.core.Point(boundBox.x + Math.round(boundBox.width), boundBox.y);
            bottomL = new marietta.core.Point(boundBox.x, boundBox.y + Math.round(boundBox.height));
            bottomR = new marietta.core.Point(boundBox.x + Math.round(boundBox.width), boundBox.y + Math.round(boundBox.height));
          } else {
            topL = new marietta.core.Point(itemList[i].itemInfo.x - Math.round(boundBox.width) / 2, itemList[i].itemInfo.y - Math.round(boundBox.height) / 2);
            topR = new marietta.core.Point(itemList[i].itemInfo.x + Math.round(boundBox.width) / 2, itemList[i].itemInfo.y - Math.round(boundBox.height) / 2);
            bottomL = new marietta.core.Point(itemList[i].itemInfo.x - Math.round(boundBox.width) / 2, itemList[i].itemInfo.y + Math.round(boundBox.height) / 2);
            bottomR = new marietta.core.Point(itemList[i].itemInfo.x + Math.round(boundBox.width) / 2, itemList[i].itemInfo.y + Math.round(boundBox.height) / 2);
          }
          switch (direction) {
            case 'top':
              crossPoint = WebCADUtil.calculateCrossPoint(bottomL, bottomR, newPoint);
              crossPointS = WebCADUtil.calculateCrossPoint(bottomL, bottomR, p1);
              crossPointE = WebCADUtil.calculateCrossPoint(bottomL, bottomR, p2);

              if (crossPoint != null && crossPoint.y < newPoint.y && ((crossPoint.x - newPoint.x) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine: false }, line: { start: bottomL, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPoint, newPoint), point: crossPoint, startPoint: newPoint,
                };
              } else if (crossPointS != null && crossPointS.y < p1.y && ((crossPointS.x - p1.x) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: bottomL, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointS, p1), point: crossPointS, startPoint: p1,
                };
              } else if (crossPointE != null && crossPointE.y < p2.y && ((crossPointE.x - p2.x) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: bottomL, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointE, p2), point: crossPointE, startPoint: p2,
                };
              }
              if (closestWall != null) {
                const rect = [p1, p2, new marietta.core.Point(p2.x, closestWall.point.y), new marietta.core.Point(p1.x, closestWall.point.y)];
                if (WebCADUtil.isPointInsidePolygon(rect, bottomL)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, bottomL);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(bottomL, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: bottomL, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(bottomL, crossPoint), point: bottomL, startPoint: crossPoint,
                    };
                  }
                }
                if (WebCADUtil.isPointInsidePolygon(rect, bottomR)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, bottomR);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(bottomR, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: bottomL, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(bottomR, crossPoint), point: bottomR, startPoint: crossPoint,
                    };
                  }
                }
              }
              break;
            case 'right':
              crossPoint = WebCADUtil.calculateCrossPoint(topL, bottomL, newPoint);
              crossPointS = WebCADUtil.calculateCrossPoint(topL, bottomL, p1);
              crossPointE = WebCADUtil.calculateCrossPoint(topL, bottomL, p2);

              if (crossPoint != null && crossPoint.x > newPoint.x && ((crossPoint.y - newPoint.y) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine: false }, line: { start: topL, end: bottomL }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPoint, newPoint), point: crossPoint, startPoint: newPoint,
                };
              } else if (crossPointS != null && crossPointS.x > p1.x && ((crossPointS.y - p1.y) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: topL, end: bottomL }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointS, p1), point: crossPointS, startPoint: p1,
                };
              } else if (crossPointE != null && crossPointE.x > p2.x && ((crossPointE.y - p2.y) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: topL, end: bottomL }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointE, p2), point: crossPointE, startPoint: p2,
                };
              }
              if (closestWall != null) {
                const rect = [p1, p2, new marietta.core.Point(closestWall.point.x, p2.y), new marietta.core.Point(closestWall.point.x, p1.y)];
                if (WebCADUtil.isPointInsidePolygon(rect, topL)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, topL);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(topL, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: topL, end: bottomL }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(topL, crossPoint), point: topL, startPoint: crossPoint,
                    };
                  }
                }
                if (WebCADUtil.isPointInsidePolygon(rect, bottomL)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, bottomL);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(bottomL, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: topL, end: bottomL }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(bottomL, crossPoint), point: bottomL, startPoint: crossPoint,
                    };
                  }
                }
              }
              break;
            case 'bottom':
              crossPoint = WebCADUtil.calculateCrossPoint(topL, topR, newPoint);
              crossPointS = WebCADUtil.calculateCrossPoint(topL, topR, p1);
              crossPointE = WebCADUtil.calculateCrossPoint(topL, topR, p2);

              if (crossPoint != null && crossPoint.y > newPoint.y && ((crossPoint.x - newPoint.x) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine: false }, line: { start: topL, end: topR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPoint, newPoint), point: crossPoint, startPoint: newPoint,
                };
              } else if (crossPointS != null && crossPointS.y > p1.y && ((crossPointS.x - p1.x) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: topL, end: topR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointS, p1), point: crossPointS, startPoint: p1,
                };
              } else if (crossPointE != null && crossPointE.y > p2.y && ((crossPointE.x - p2.x) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: topL, end: topR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointE, p2), point: crossPointE, startPoint: p2,
                };
              }
              if (closestWall != null) {
                const rect = [p1, p2, new marietta.core.Point(p2.x, closestWall.point.y), new marietta.core.Point(p1.x, closestWall.point.y)];
                if (WebCADUtil.isPointInsidePolygon(rect, topL)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, topL);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(topL, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: topL, end: topR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(topL, crossPoint), point: topL, startPoint: crossPoint,
                    };
                  }
                }
                if (WebCADUtil.isPointInsidePolygon(rect, topR)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, topR);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(topR, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: topL, end: topR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(topR, crossPoint), point: topR, startPoint: crossPoint,
                    };
                  }
                }
              }
              break;
            case 'left':
              crossPoint = WebCADUtil.calculateCrossPoint(topR, bottomR, newPoint);
              crossPointS = WebCADUtil.calculateCrossPoint(topR, bottomR, p1);
              crossPointE = WebCADUtil.calculateCrossPoint(topR, bottomR, p2);

              if (crossPoint != null && crossPoint.x < newPoint.x && ((crossPoint.y - newPoint.y) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine: false }, line: { start: topR, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPoint, newPoint), point: crossPoint, startPoint: newPoint,
                };
              } else if (crossPointS != null && crossPointS.x < p1.x && ((crossPointS.y - p1.y) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: topR, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointS, p1), point: crossPointS, startPoint: p1,
                };
              } else if (crossPointE != null && crossPointE.x < p2.x && ((crossPointE.y - p2.y) < ALMOST_ZERO)) {
                closestItem = {
                  diffLine: { showDiffLine }, line: { start: topR, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(crossPointE, p2), point: crossPointE, startPoint: p2,
                };
              }
              if (closestWall != null) {
                const rect = [p1, p2, new marietta.core.Point(closestWall.point.x, p2.y), new marietta.core.Point(closestWall.point.x, p1.y)];
                if (WebCADUtil.isPointInsidePolygon(rect, topR)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, topR);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(topR, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: topR, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(topR, crossPoint), point: topR, startPoint: crossPoint,
                    };
                  }
                }
                if (WebCADUtil.isPointInsidePolygon(rect, bottomR)) {
                  crossPoint = WebCADUtil.calculateCrossPoint(p1, p2, bottomR);
                  if (crossPoint != null && (((closestItem != null && closestItem.distance > marietta.core.Point.distance(bottomR, crossPoint)) || closestItem == null))) {
                    closestItem = {
                      diffLine: { showDiffLine }, line: { start: topR, end: bottomR }, isItem: true, item: itemList[i], distance: marietta.core.Point.distance(bottomR, crossPoint), point: bottomR, startPoint: crossPoint,
                    };
                  }
                }
              }
              break;
            default: break;
          }
          if (closestItem) { closestItems.push(closestItem); }
        }
      }

      if (closestItems.length > 0) {
        let minDistance = NaN;
        for (let i = 0; i < closestItems.length; i += 1) {
          if (Number.isNaN(minDistance) || closestItems[i].distance < minDistance) {
            minDistance = closestItems[i].distance;
            closestItem = closestItems[i];
          }
        }
        if (closestItem.distance < closestWall.distance) {
          if (closestItem.diffLine.showDiffLine) {
            if (closestItem.diffLine.showDiffLine) { closestItem.diffLine.diffLinePoint = this.getGuideLinePoints(closestItem.line, p1, p2); }
          }
          return closestItem;
        }
      }
      return null;
    }

    /**
     * ガイドラインの始点と終点を計算
     * @param line
     * @param p1
     * @param p2
     */
    static getGuideLinePoints(line: { start: marietta.webcad.view.dialog.core.Point; end: marietta.webcad.view.dialog.core.Point; }, p1: marietta.webcad.view.dialog.core.Point, p2: marietta.webcad.view.dialog.core.Point): marietta.core.Point {
      const centerPoint: marietta.core.Point = marietta.core.Point.interpolate(p1, p2, 0.5);
      if (this.target instanceof marietta.webcad.item.Column) {
        const boundBox = this.target.getBoundRect();
        const cp = new marietta.core.Point(boundBox.x + Math.round(boundBox.width) / 2, boundBox.y + Math.round(boundBox.height) / 2);
        if (marietta.core.Point.distance(line.start, centerPoint) < marietta.core.Point.distance(line.end, centerPoint)) {
          return new marietta.core.Point((line.start.x - cp.x), (line.start.y - cp.y));
        }
        return new marietta.core.Point((line.end.x - cp.x), (line.end.y - cp.y));
      }
      if (marietta.core.Point.distance(line.start, centerPoint) < marietta.core.Point.distance(line.end, centerPoint)) {
        return new marietta.core.Point((line.start.x - this.target.itemInfo.x), (line.start.y - this.target.itemInfo.y));
      }
      return new marietta.core.Point((line.end.x - this.target.itemInfo.x), (line.end.y - this.target.itemInfo.y));
    }
}
